import { computed } from "vue";
import type { CompanyRow } from "./bulkBuyTypes";

/**
 * Volume/price totals over a set of beneficiary rows — the single derivation
 * shared by the summary footer (all rows) and the review modal (complete rows).
 */
export function useBulkBuyTotals(rows: () => CompanyRow[]) {
  const totalVolume = computed(() =>
    rows().reduce((sum, row) => sum + row.volume, 0)
  );

  const pricedRows = computed(() =>
    rows().filter((row) => row.pricing_state.status === "success")
  );

  const totalKnownVolume = computed(() =>
    pricedRows.value.reduce((sum, row) => sum + row.volume, 0)
  );

  const totalKnownPrice = computed(() =>
    pricedRows.value.reduce(
      (sum, row) =>
        sum +
        (row.pricing_state.status === "success" ? row.pricing_state.price : 0),
      0
    )
  );

  const agentReachOutRows = computed(() =>
    rows().filter((row) => row.pricing_state.status === "agent_reach_out")
  );

  const agentReachOutCount = computed(() => agentReachOutRows.value.length);

  const agentReachOutVolume = computed(() =>
    agentReachOutRows.value.reduce((sum, row) => sum + row.volume, 0)
  );

  return {
    totalVolume,
    totalKnownVolume,
    totalKnownPrice,
    agentReachOutRows,
    agentReachOutCount,
    agentReachOutVolume,
  };
}
